import { jsx as _jsx } from "react/jsx-runtime";
import ReactModal from 'react-modal';
export const PopupContainer = ({ children = null, isOpen = false, onClose = () => ({}), }) => {
    const modalStyles = {
        overlay: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgba(0,0,0,0.3)',
        },
        content: {
            padding: '0',
            inset: 'auto',
            border: 0,
            width: 'var(--moveo-chat-width)',
            height: 'var(--moveo-chat-height)',
            borderRadius: '8px',
        },
    };
    return (_jsx(ReactModal, { style: modalStyles, isOpen: isOpen, onRequestClose: onClose, shouldCloseOnOverlayClick: false, ariaHideApp: false, parentSelector: () => document.querySelector('.appContainer'), children: children }));
};
